import React from 'react'
import styled from 'styled-components'
import { AddNewLeadsFirst } from '../../Components/Leads/Add new leads/AddNewLeadsFirst'

export const AddNewLeadsComponent = () => {
  return (
    <Main>
        <AddNewLeadsFirst/>
    </Main>
  )
}

const Main = styled.div`
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-height: calc(100vh - 10vh);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`